module.exports = __webpack_public_path__ + "img/Patent_6.f99e6a13.png";